// extracted by mini-css-extract-plugin
module.exports = {"geo-links":"GeolocTemplate_geo-links__fIJ48"};